import React, { useState, useEffect, useRef } from 'react';
import ICONS from '../config/icon';
import CourseCard from './CourseCard';
import { useInsertName } from "./utils/helpers";

import { PaperBG, PaperDarkBG, UnderlineSketch } from '../kits';
import MonoButton from './MonoButton';
import { Link } from 'react-router-dom';
import CustomCourseRequestPr from './CustomCourseRequestPr';
import ModalWrapper from './utils/ModalWrapper';
import { createPortal } from "react-dom";



function SectionC() {
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const coursesSectionRef = useRef(null);
  const name = useInsertName();
    const [showModal, setShowModal] = useState(false);



      const handleCloseModal = () => {
  setShowModal(false);
  setSearchQuery("");
  setIsSearching(false);
  setFilteredCourses([]);
};

  useEffect(() => {
    if (isSearching && filteredCourses.length === 0) {
      setShowModal(true);
    }
  }, [isSearching, filteredCourses]);


  // Kurse vom Backend laden
  useEffect(() => {
    fetch("https://www.denisbitter.de/stage01/api/get_courses.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.data)) {
          setCourses(data.data);
        } else {
          console.error('Ungültige Kursdaten.');
        }
      })
      .catch((err) => console.error('Fehler beim Laden:', err));
  }, []);

  // Suche ausführen
  const performSearch = (query) => {
    const regex = new RegExp(
      query
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '.*')
        .split(' ')
        .map(word => `(?=.*${word})`)
        .join(''),
      'i'
    );



    const results = courses.filter((course) => {
      const descriptionText = Array.isArray(course.description)
        ? course.description.join(' ')
        : course.description || '';

      return (
        regex.test(course.title) ||
        regex.test(descriptionText) ||
        regex.test(course.instructor) ||
        regex.test(course.category)
      );
    });

    setFilteredCourses(results);
    setIsSearching(true);

    if (results.length > 0 && coursesSectionRef.current) {
      window.scrollTo({
        top: coursesSectionRef.current.offsetTop - 100,
        behavior: 'smooth',
      });
    }
  };

  // Input-Änderung verarbeiten
  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchQuery(value);

    if (value.trim() === '') {
      setIsSearching(false);
      setFilteredCourses([]);
    } else {
      performSearch(value);
    }
  };

  return (
    <>
    <PaperBG>
    <div>
      {/* Sucheingabe */}
      <PaperDarkBG>
      <section className="py-24 ">
 
    <div className="max-w-5xl mx-auto px-6 text-center text-white">
      
      <h2 className="text-md sm:text-xl font-mono mb-2">
        Was interessiert <br /> dich gerade, <span className="inline-block relative text-orange-300">
          {name}
          <UnderlineSketch className="absolute -bottom-2 left-0 w-full h-2"
          color="colorWhite"
          />
           
        </span>
      </h2>

   

      <div className="relative max-w-3xl mx-auto py-5">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchInputChange}
          placeholder="3D , Web, React ..."
          className="w-full px-6 py-4 text-gray-900 text-xs font-mono sm:text-center bg-gray-50 border border-gray-700 rounded-xl focus:outline-none focus:ring-1 focus:ring-white/20 placeholder-gray-500"
        />
        <span className="absolute right-6 top-4 text-gray-500 text-xs sm:text-xl"></span>
      </div>

    </div>

</section>
</PaperDarkBG>




      {/* Suchergebnisse */}
      {isSearching && (
        <section ref={coursesSectionRef} className="py-16 bg-gray-50">
          <div className="container mx-auto px-6">
            {filteredCourses.length > 0 ? (
              <>
                <h3 className="text-xs font-mono mb-10 text-center">
                  Ich habe ein paar Kurse gefunden, die dich interessieren könnten, {name}.
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                  {filteredCourses.map((course) => (
                    <CourseCard
                      key={course.id}
                      course={course}
                      icon={ICONS[course.icon] || ICONS.default}
                    />
                  ))}
                </div>
              </>
            ) : (
              <div className="text-center font-mono">
{showModal &&
  typeof document !== "undefined" &&
  document.getElementById("modal-root") &&
  createPortal(
    <ModalWrapper onClose={handleCloseModal}>
      <CustomCourseRequestPr onClose={handleCloseModal} />
    </ModalWrapper>,
    document.getElementById("modal-root")
  )
}
              </div>
            )}
          </div>
                 
        </section>

      )}
    </div>
    </PaperBG>
    </>
  );
}

export default SectionC;
